/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MagiExtractType {
  PLUS_INSIGHT = 'plus-insight',
  PRO_INTERNAL = 'pro-internal',
  PRO_SALESWISE = 'pro-saleswise',
}
